import {
    GET_AUTOMATED_DISCOUNTS,
    GET_AUTOMATED_DISCOUNTS_ERROR,
    GET_AUTOMATED_DISCOUNTS_SUCCESS,
} from "core-web/state/models/Page/constants";
import { handleAllVariants, isPackageProduct, isVariantProduct } from "core-web/containers/ProductPageContainer";

import { SAVE_AUTOMATED_DISCOUNT } from "core-web/state/models/Products/constants";
import getGoogleDiscountData from "core-web/utils/getGoogleDiscountData";
import getSpecialPriceData from "core-web/utils/getSpecialPriceData";
import store from "core-web/state/store";

export const getProductAutomatedDiscounts =
    (product, location, url, applicationId, ssrCookies) => async (dispatch, getState) => {
        dispatch({ type: GET_AUTOMATED_DISCOUNTS });

        try {
            const query = getState("search")?.query;

            if (!product) {
                throw new Error("Automated discounts, no product.");
            }

            const googleDiscount = await getGoogleDiscountData(
                product.variants || [],
                product.part_no,
                location,
                url,
                applicationId,
                ssrCookies,
            );
            const specialPrice = await getSpecialPriceData(
                product.variants || [],
                product.part_no,
                location,
                url,
                applicationId,
                ssrCookies,
            );

            const variants = handleAllVariants(product.variants, googleDiscount, specialPrice);

            const isVariant = isVariantProduct(product);
            const isPackage = isPackageProduct(product);

            const hasPartNo = product.variants.some((p) => p.part_no === query?.p);

            const presetPartNoLocationState = location.state?.presetPartNo;
            const hasPresetPartNo = product.variants.some((p) => p.part_no === presetPartNoLocationState);

            const selectedProductVariants = {};
            if (
                !(isPackage && !isVariant && (product.included_products || []).length) &&
                !(isVariant && !hasPartNo && !hasPresetPartNo) &&
                !(isVariant && (hasPartNo || hasPresetPartNo))
            ) {
                selectedProductVariants[product.id] = JSON.parse(JSON.stringify(product));
                if (googleDiscount) {
                    const googleDiscountPriceExVat = googleDiscount.discountPriceIncVat / product.vat_rate;
                    selectedProductVariants[product.id].googleDiscountExpirationDate =
                        googleDiscount.discountExpirationDate;
                    selectedProductVariants[product.id].googleDiscountPrice = googleDiscountPriceExVat;
                    selectedProductVariants[product.id].googleDiscountTimeStamp = googleDiscount.discountTimeStamp;
                } else if (specialPrice) {
                    const specialPriceExVat = specialPrice.discountPriceIncVat / product.vat_rate;
                    selectedProductVariants[product.id].specialPriceExpirationDate =
                        specialPrice.discountExpirationDate;
                    selectedProductVariants[product.id].specialPrice = specialPriceExVat;
                    selectedProductVariants[product.id].specialPriceTimeStamp = specialPrice.discountTimeStamp;
                }
            }

            const transformedProduct = selectedProductVariants[product.id];

            if (googleDiscount) {
                const googleDiscountPriceExVat = googleDiscount.discountPriceIncVat / product.vat_rate;

                dispatch({
                    type: GET_AUTOMATED_DISCOUNTS_SUCCESS,
                    selectedProductVariants,
                    product: transformedProduct,
                    variants,
                    automatedDiscountData: {
                        ...googleDiscount,
                        provider: "google",
                    },
                });

                dispatch({
                    type: SAVE_AUTOMATED_DISCOUNT,
                    automatedDiscountData: {
                        ...googleDiscount,
                        discountPriceExVat: googleDiscountPriceExVat,
                        provider: "google",
                    },
                    partNo: product.part_no,
                });

                return;
            }

            if (specialPrice) {
                const specialPriceExVat = specialPrice.discountPriceIncVat / product.vat_rate;

                dispatch({
                    type: GET_AUTOMATED_DISCOUNTS_SUCCESS,
                    selectedProductVariants,
                    product: transformedProduct,
                    variants,
                    automatedDiscountData: {
                        ...specialPrice,
                        provider: "api",
                    },
                });

                dispatch({
                    type: SAVE_AUTOMATED_DISCOUNT,
                    automatedDiscountData: {
                        ...specialPrice,
                        discountPriceExVat: specialPriceExVat,
                        provider: "google",
                    },
                    partNo: product.part_no,
                });

                return;
            }

            dispatch({ type: GET_AUTOMATED_DISCOUNTS_ERROR });
        } catch (e) {
            dispatch({ type: GET_AUTOMATED_DISCOUNTS_ERROR });
        }
    };

export default (product, location, url, applicationId, ssrCookies = {}) =>
    store.dispatch(getProductAutomatedDiscounts(product, location, url, applicationId, ssrCookies));
